import React from 'react'
import { formatCurrency } from '../../utils/api'
import { CANNOT_ISSUE_WORDS } from '../../utils/storeCredit'

/**
 * Both figures of a store credit payout: the cash value (the buy price) and the
 * credit the seller is paid. Words carry the meaning, never colour alone.
 * `figures` comes from utils/storeCredit.js; null shows how to get them.
 */
export default function StoreCreditFigures({ figures, onShow, showing }) {
  if (!figures) {
    return (
      <div data-store-credit-figures style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <span style={{ color: 'var(--muted)' }}>The seller chose store credit.</span>
        {onShow && (
          <button
            className="btn btn-sm btn-secondary"
            style={{ marginTop: 4, alignSelf: 'flex-start' }}
            disabled={showing}
            onClick={e => { e.stopPropagation(); onShow() }}
          >
            {showing ? 'Reading…' : 'Show credit figure'}
          </button>
        )}
      </div>
    )
  }
  return (
    <div data-store-credit-figures style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <div><span style={{ color: 'var(--muted)' }}>Cash value (buy price):</span> {formatCurrency(figures.cashPounds)}</div>
      <div>
        <span style={{ color: 'var(--muted)' }}>Store credit to issue:</span>{' '}
        <strong>{formatCurrency(figures.creditPounds)}</strong>
        {figures.percent && <span style={{ color: 'var(--muted)' }}> (+{figures.percent})</span>}
      </div>
      {figures.issuedAt && <div style={{ color: 'var(--muted)' }}>Issued</div>}
      {!figures.canIssue && (
        <div role="alert" style={{ fontSize: 12, color: '#92400e', background: '#fef3c7', padding: '4px 8px', borderRadius: 4 }}>
          <strong>Cannot issue.</strong> {CANNOT_ISSUE_WORDS[figures.reason] || figures.reason}
        </div>
      )}
    </div>
  )
}
